import { filterFlag, IConfigItemProps } from '@component/search/type';

// 注册资本
export const regCapital = [
  { val: '*', title: '全部' },
  { val: '0100', start: 0, end: 100, title: '0～100万', sort: 1 },
  { val: '100200', start: 100, end: 200, title: '100～200万', sort: 2 },
  { val: '200500', start: 200, end: 500, title: '200～500万', sort: 3 },
  { val: '5001000', start: 500, end: 1000, title: '500～1000万', sort: 4 },
  { val: '1000', start: 1000, end: null, title: '1000万以上', sort: 5 },
];

// 成立时间
export const estiblishTime = [
  { val: '*', title: '全部' },
  { val: '01', start: 0, end: 1, title: '成立1年内', sort: 1 },
  { val: '015', start: 1, end: 5, title: '成立1～5年', sort: 2 },
  { val: '510', start: 5, end: 10, title: '成立5～10年', sort: 3 },
  { val: '1015', start: 10, end: 15, title: '成立10～15年', sort: 4 },
  { val: '15', start: 15, end: 200, title: '成立15年以上', sort: 5 },
];

// 行业数据
export const cateList = [
  { title: '全部', val: '*', secList: [] },
  {
    title: '农、林、牧、渔业',
    val: 'A',
    secList: [
      { title: '全部', val: 'A' },
      {
        title: '农业',
        val: '01',
        terList: [
          { title: '全部', val: '01' },
          { title: '谷物种植', val: '011' },
          { title: '豆类、油料和薯类种植', val: '012' },
          { title: '棉、麻、糖、烟草种植', val: '013' },
          { title: '蔬菜、食用菌及园艺作物种植', val: '014' },
          { title: '水果种植', val: '015' },
          { title: '坚果、含油果、香料和饮料作物种植', val: '016' },
          { title: '中药材种植', val: '017' },
          { title: '草种植及割草', val: '018' },
          { title: '其他农业', val: '019' },
        ],
      },
      {
        title: '林业',
        val: '02',
        terList: [
          { title: '全部', val: '02' },
          { title: '林木育种和育苗', val: '021' },
          { title: '造林和更新', val: '022' },
          { title: '森林经营、管护和改培', val: '023' },
          { title: '木材和竹材采运', val: '024' },
          { title: '林产品采集', val: '025' },
        ],
      },
      {
        title: '畜牧业',
        val: '03',
        terList: [
          { title: '全部', val: '03' },
          { title: '牲畜饲养', val: '031' },
          { title: '家禽饲养', val: '032' },
          { title: '狩猎和捕捉动物', val: '033' },
          { title: '其他畜牧业', val: '039' },
        ],
      },
      {
        title: '渔业',
        val: '04',
        terList: [
          { title: '全部', val: '04' },
          { title: '水产养殖', val: '041' },
          { title: '水产捕捞', val: '042' },
        ],
      },
      {
        title: '农、林、牧、渔专业及辅助性活动',
        val: '05',
        terList: [
          { title: '全部', val: '05' },
          { title: '农业专业及辅助性活动', val: '051' },
          { title: '林业专业及辅助性活动', val: '052' },
          { title: '畜牧专业及辅助性活动', val: '053' },
          { title: '渔业专业及辅助性活动', val: '054' },
        ],
      },
    ],
  },
  {
    title: '采矿业',
    val: 'B',
    secList: [
      { title: '全部', val: 'B' },
      {
        title: '煤炭开采和洗选业',
        val: '06',
        terList: [
          { title: '全部', val: '06' },
          { title: '烟煤和无烟煤开采洗选', val: '061' },
          { title: '褐煤开采洗选', val: '062' },
          { title: '其他煤炭采选', val: '069' },
        ],
      },
      {
        title: '石油和天然气开采业',
        val: '07',
        terList: [
          { title: '全部', val: '07' },
          { title: '石油开采', val: '071' },
          { title: '天然气开采', val: '072' },
        ],
      },
      {
        title: '黑色金属矿采选业',
        val: '08',
        terList: [
          { title: '全部', val: '08' },
          { title: '铁矿采选', val: '081' },
          { title: '锰矿、铬矿采选', val: '082' },
          { title: '其他黑色金属矿采选', val: '089' },
        ],
      },
      {
        title: '有色金属矿采选业',
        val: '09',
        terList: [
          { title: '全部', val: '09' },
          { title: '常用有色金属矿采选', val: '091' },
          { title: '贵金属矿采选', val: '092' },
          { title: '稀有稀土金属矿采选', val: '093' },
        ],
      },
      {
        title: '非金属矿采选业',
        val: '10',
        terList: [
          { title: '全部', val: '10' },
          { title: '土砂石开采', val: '101' },
          { title: '化学矿开采', val: '102' },
          { title: '采盐', val: '103' },
          { title: '石棉及其他非金属矿采选', val: '109' },
        ],
      },
      {
        title: '开采专业及辅助性活动',
        val: '11',
        terList: [
          { title: '全部', val: '11' },
          { title: '煤炭开采和洗选专业及辅助性活动', val: '111' },
          { title: '石油和天然气开采专业及辅助性活动', val: '112' },
          { title: '其他开采专业及辅助性活动', val: '119' },
        ],
      },
      {
        title: '其他采矿业',
        val: '12',
        terList: [
          { title: '全部', val: '12' },
          { title: '其他采矿业', val: '120' },
        ],
      },
    ],
  },
  {
    title: '制造业',
    val: 'C',
    secList: [
      { title: '全部', val: 'C' },
      {
        title: '农副食品加工业',
        val: '13',
        terList: [
          { title: '全部', val: '13' },
          { title: '谷物磨制', val: '131' },
          { title: '饲料加工', val: '132' },
          { title: '植物油加工', val: '133' },
          { title: '制糖业', val: '134' },
          { title: '屠宰及肉类加工', val: '135' },
          { title: '水产品加工', val: '136' },
          { title: '蔬菜、菌类、水果和坚果加工', val: '137' },
          { title: '其他农副食品加工', val: '139' },
        ],
      },
      {
        title: '食品制造业',
        val: '14',
        terList: [
          { title: '全部', val: '14' },
          { title: '焙烤食品制造', val: '141' },
          { title: '糖果、巧克力及蜜饯制造', val: '142' },
          { title: '方便食品制造', val: '143' },
          { title: '乳制品制造', val: '144' },
          { title: '罐头食品制造', val: '145' },
          { title: '调味品、发酵制品制造', val: '146' },
          { title: '其他食品制造', val: '149' },
        ],
      },
      {
        title: '酒、饮料和精制茶制造业',
        val: '15',
        terList: [
          { title: '全部', val: '15' },
          { title: '酒的制造', val: '151' },
          { title: '饮料制造', val: '152' },
          { title: '精制茶加工', val: '153' },
        ],
      },
      {
        title: '烟草制品业',
        val: '16',
        terList: [
          { title: '全部', val: '16' },
          { title: '烟叶复烤', val: '161' },
          { title: '卷烟制造', val: '162' },
          { title: '其他烟草制品制造', val: '169' },
        ],
      },
      {
        title: '纺织业',
        val: '17',
        terList: [
          { title: '全部', val: '17' },
          { title: '棉纺织及印染精加工', val: '171' },
          { title: '毛纺织及染整精加工', val: '172' },
          { title: '麻纺织及染整精加工', val: '173' },
          { title: '丝绢纺织及印染精加工', val: '174' },
          { title: '化纤织造及印染精加工', val: '175' },
          { title: '针织或钩针编织物及其制品制造', val: '176' },
          { title: '家用纺织制成品制造', val: '177' },
          { title: '产业用纺织制成品制造', val: '178' },
        ],
      },
      {
        title: '纺织服装、服饰业',
        val: '18',
        terList: [
          { title: '全部', val: '18' },
          { title: '机织服装制造', val: '181' },
          { title: '针织或钩针编织服装制造', val: '182' },
          { title: '服饰制造', val: '183' },
        ],
      },
      {
        title: '皮革、毛皮、羽毛及其制品和制鞋业',
        val: '19',
        terList: [
          { title: '全部', val: '19' },
          { title: '皮革鞣制加工', val: '191' },
          { title: '皮革制品制造', val: '192' },
          { title: '毛皮鞣制及制品加工', val: '193' },
          { title: '羽毛(绒)加工及制品制造', val: '194' },
          { title: '制鞋业', val: '195' },
        ],
      },
      {
        title: '木材加工和木、竹、藤、棕、草制品业',
        val: '20',
        terList: [
          { title: '全部', val: '20' },
          { title: '木材加工', val: '201' },
          { title: '人造板制造', val: '202' },
          { title: '木质制品制造', val: '203' },
          { title: '竹、藤、棕、草等制品制造', val: '204' },
        ],
      },
      {
        title: '家具制造业',
        val: '21',
        terList: [
          { title: '全部', val: '21' },
          { title: '木质家具制造', val: '211' },
          { title: '竹、藤家具制造', val: '212' },
          { title: '金属家具制造', val: '213' },
          { title: '塑料家具制造', val: '214' },
          { title: '其他家具制造', val: '219' },
        ],
      },
      {
        title: '造纸和纸制品业',
        val: '22',
        terList: [
          { title: '全部', val: '22' },
          { title: '纸浆制造', val: '221' },
          { title: '造纸', val: '222' },
          { title: '纸制品制造', val: '223' },
        ],
      },
      {
        title: '印刷和记录媒介复制业',
        val: '23',
        terList: [
          { title: '全部', val: '23' },
          { title: '印刷', val: '231' },
          { title: '装订及印刷相关服务', val: '232' },
          { title: '记录媒介复制', val: '233' },
        ],
      },
      {
        title: '文教、工美、体育和娱乐用品制造业',
        val: '24',
        terList: [
          { title: '全部', val: '24' },
          { title: '文教办公用品制造', val: '241' },
          { title: '乐器制造', val: '242' },
          { title: '工艺美术及礼仪用品制造', val: '243' },
          { title: '体育用品制造', val: '244' },
          { title: '玩具制造', val: '245' },
          { title: '游艺器材及娱乐用品制造', val: '246' },
        ],
      },
      {
        title: '石油、煤炭及其他燃料加工业',
        val: '25',
        terList: [
          { title: '全部', val: '25' },
          { title: '精炼石油产品制造', val: '251' },
          { title: '煤炭加工', val: '252' },
          { title: '核燃料加工', val: '253' },
          { title: '生物质燃料加工', val: '254' },
        ],
      },
      {
        title: '化学原料和化学制品制造业',
        val: '26',
        terList: [
          { title: '全部', val: '26' },
          { title: '基础化学原料制造', val: '261' },
          { title: '肥料制造', val: '262' },
          { title: '农药制造', val: '263' },
          { title: '涂料、油墨、颜料及类似产品制造', val: '264' },
          { title: '合成材料制造', val: '265' },
          { title: '专用化学产品制造', val: '266' },
          { title: '炸药、火工及焰火产品制造', val: '267' },
          { title: '日用化学产品制造', val: '268' },
        ],
      },
      {
        title: '医药制造业',
        val: '27',
        terList: [
          { title: '全部', val: '27' },
          { title: '化学药品原料药制造', val: '271' },
          { title: '化学药品制剂制造', val: '272' },
          { title: '中药饮片加工', val: '273' },
          { title: '中成药生产', val: '274' },
          { title: '兽用药品制造', val: '275' },
          { title: '生物药品制品制造', val: '276' },
          { title: '卫生材料及医药用品制造', val: '277' },
          { title: '药用辅料及包装材料', val: '278' },
        ],
      },
      {
        title: '化学纤维制造业',
        val: '28',
        terList: [
          { title: '全部', val: '28' },
          { title: '纤维素纤维原料及纤维制造', val: '281' },
          { title: '合成纤维制造', val: '282' },
          { title: '生物基材料制造', val: '283' },
        ],
      },
      {
        title: '橡胶和塑料制品业',
        val: '29',
        terList: [
          { title: '全部', val: '29' },
          { title: '橡胶制品业', val: '291' },
          { title: '塑料制品业', val: '292' },
        ],
      },
      {
        title: '非金属矿物制品业',
        val: '30',
        terList: [
          { title: '全部', val: '30' },
          { title: '水泥、石灰和石膏制造', val: '301' },
          { title: '石膏、水泥制品及类似制品制造', val: '302' },
          { title: '砖瓦、石材等建筑材料制造', val: '303' },
          { title: '玻璃制造', val: '304' },
          { title: '玻璃制品制造', val: '305' },
          { title: '玻璃纤维和玻璃纤维增强塑料制品制造', val: '306' },
          { title: '陶瓷制品制造', val: '307' },
          { title: '耐火材料制品制造', val: '308' },
          { title: '石墨及其他非金属矿物制品制造', val: '309' },
        ],
      },
      {
        title: '黑色金属冶炼和压延加工业',
        val: '31',
        terList: [
          { title: '全部', val: '31' },
          { title: '炼铁', val: '311' },
          { title: '炼钢', val: '312' },
          { title: '钢压延加工', val: '313' },
          { title: '铁合金冶炼', val: '314' },
        ],
      },
      {
        title: '有色金属冶炼和压延加工业',
        val: '32',
        terList: [
          { title: '全部', val: '32' },
          { title: '常用有色金属冶炼', val: '321' },
          { title: '贵金属冶炼', val: '322' },
          { title: '稀有稀土金属冶炼', val: '323' },
          { title: '有色金属合金制造', val: '324' },
          { title: '有色金属压延加工', val: '325' },
        ],
      },
      {
        title: '金属制品业',
        val: '33',
        terList: [
          { title: '全部', val: '33' },
          { title: '结构性金属制品制造', val: '331' },
          { title: '金属工具制造', val: '332' },
          { title: '集装箱及金属包装容器制造', val: '333' },
          { title: '金属丝绳及其制品制造', val: '334' },
          { title: '建筑、安全用金属制品制造', val: '335' },
          { title: '金属表面处理及热处理加工', val: '336' },
          { title: '搪瓷制品制造', val: '337' },
          { title: '金属制日用品制造', val: '338' },
          { title: '铸造及其他金属制品制造', val: '339' },
        ],
      },
      {
        title: '通用设备制造业',
        val: '34',
        terList: [
          { title: '全部', val: '34' },
          { title: '锅炉及原动设备制造', val: '341' },
          { title: '金属加工机械制造', val: '342' },
          { title: '物料搬运设备制造', val: '343' },
          { title: '泵、阀门、压缩机及类似机械制造', val: '344' },
          { title: '轴承、齿轮和传动部件制造', val: '345' },
          { title: '烘炉、风机、包装等设备制造', val: '346' },
          { title: '文化、办公用机械制造', val: '347' },
          { title: '通用零部件制造', val: '348' },
          { title: '其他通用设备制造业', val: '349' },
        ],
      },
      {
        title: '专用设备制造业',
        val: '35',
        terList: [
          { title: '全部', val: '35' },
          { title: '采矿、冶金、建筑专用设备制造', val: '351' },
          { title: '化工、木材、非金属加工专用设备制造', val: '352' },
          { title: '食品、饮料、烟草及饲料生产专用设备制造', val: '353' },
          { title: '印刷、制药、日化及日用品生产专用设备制造', val: '354' },
          { title: '纺织、服装和皮革加工专用设备制造', val: '355' },
          { title: '电子和电工机械专用设备制造', val: '356' },
          { title: '农、林、牧、渔专用机械制造', val: '357' },
          { title: '医疗仪器设备及器械制造', val: '358' },
          { title: '环保、邮政、社会公共服务及其他专用设备制造', val: '359' },
        ],
      },
      {
        title: '汽车制造业',
        val: '36',
        terList: [
          { title: '全部', val: '36' },
          { title: '汽车整车制造', val: '361' },
          { title: '汽车用发动机制造', val: '362' },
          { title: '改装汽车制造', val: '363' },
          { title: '低速汽车制造', val: '364' },
          { title: '电车制造', val: '365' },
          { title: '汽车车身、挂车制造', val: '366' },
          { title: '汽车零部件及配件制造', val: '367' },
        ],
      },
      {
        title: '铁路、船舶、航空航天和其他运输设备制造业',
        val: '37',
        terList: [
          { title: '全部', val: '37' },
          { title: '铁路运输设备制造', val: '371' },
          { title: '城市轨道交通设备制造', val: '372' },
          { title: '船舶及相关装置制造', val: '373' },
          { title: '航空、航天器及设备制造', val: '374' },
          { title: '摩托车制造', val: '375' },
          { title: '自行车和残疾人座车制造', val: '376' },
          { title: '助动车制造', val: '377' },
          { title: '非公路休闲车及零配件制造', val: '378' },
          { title: '潜水救捞及其他未列明运输设备制造', val: '379' },
        ],
      },
      {
        title: '电气机械和器材制造业',
        val: '38',
        terList: [
          { title: '全部', val: '38' },
          { title: '电机制造', val: '381' },
          { title: '输配电及控制设备制造', val: '382' },
          { title: '电线、电缆、光缆及电工器材制造', val: '383' },
          { title: '电池制造', val: '384' },
          { title: '家用电力器具制造', val: '385' },
          { title: '非电力家用器具制造', val: '386' },
          { title: '照明器具制造', val: '387' },
          { title: '其他电气机械及器材制造', val: '389' },
        ],
      },
      {
        title: '计算机、通信和其他电子设备制造业',
        val: '39',
        terList: [
          { title: '全部', val: '39' },
          { title: '计算机制造', val: '391' },
          { title: '通信设备制造', val: '392' },
          { title: '广播电视设备制造', val: '393' },
          { title: '雷达及配套设备制造', val: '394' },
          { title: '非专业视听设备制造', val: '395' },
          { title: '智能消费设备制造', val: '396' },
          { title: '电子器件制造', val: '397' },
          { title: '电子元件及电子专用材料制造', val: '398' },
          { title: '其他电子设备制造', val: '399' },
        ],
      },
      {
        title: '仪器仪表制造业',
        val: '40',
        terList: [
          { title: '全部', val: '40' },
          { title: '通用仪器仪表制造', val: '401' },
          { title: '专用仪器仪表制造', val: '402' },
          { title: '钟表与计时仪器制造', val: '403' },
          { title: '光学仪器制造', val: '404' },
          { title: '衡器制造', val: '405' },
          { title: '其他仪器仪表制造业', val: '409' },
        ],
      },
      {
        title: '其他制造业',
        val: '41',
        terList: [
          { title: '全部', val: '41' },
          { title: '日用杂品制造', val: '411' },
          { title: '核辐射加工', val: '412' },
          { title: '其他未列明制造业', val: '419' },
        ],
      },
      {
        title: '废弃资源综合利用业',
        val: '42',
        terList: [
          { title: '全部', val: '42' },
          { title: '金属废料和碎屑加工处理', val: '421' },
          { title: '非金属废料和碎屑加工处理', val: '422' },
        ],
      },
      {
        title: '金属制品、机械和设备修理业',
        val: '43',
        terList: [
          { title: '全部', val: '43' },
          { title: '金属制品修理', val: '431' },
          { title: '通用设备修理', val: '432' },
          { title: '专用设备修理', val: '433' },
          { title: '铁路、船舶、航空航天等运输设备修理', val: '434' },
          { title: '电气设备修理', val: '435' },
          { title: '仪器仪表修理', val: '436' },
          { title: '其他机械和设备修理业', val: '439' },
        ],
      },
    ],
  },
  {
    title: '电力、热力、燃气及水生产和供应业',
    val: 'D',
    secList: [
      { title: '全部', val: 'D' },
      {
        title: '电力、热力生产和供应业',
        val: '44',
        terList: [
          { title: '全部', val: '44' },
          { title: '电力生产', val: '441' },
          { title: '电力供应', val: '442' },
          { title: '热力生产和供应', val: '443' },
        ],
      },
      {
        title: '燃气生产和供应业',
        val: '45',
        terList: [
          { title: '全部', val: '45' },
          { title: '燃气生产和供应业', val: '451' },
          { title: '生物质燃气生产和供应业', val: '452' },
        ],
      },
      {
        title: '水的生产和供应业',
        val: '46',
        terList: [
          { title: '全部', val: '46' },
          { title: '自来水生产和供应', val: '461' },
          { title: '污水处理及其再生利用', val: '462' },
          { title: '海水淡化处理', val: '463' },
          { title: '其他水的处理、利用与分配', val: '469' },
        ],
      },
    ],
  },
  {
    title: '建筑业',
    val: 'E',
    secList: [
      { title: '全部', val: 'E' },
      {
        title: '房屋建筑业',
        val: '47',
        terList: [
          { title: '全部', val: '47' },
          { title: '住宅房屋建筑', val: '471' },
          { title: '体育场馆建筑', val: '472' },
          { title: '其他房屋建筑业', val: '479' },
        ],
      },
      {
        title: '土木工程建筑业',
        val: '48',
        terList: [
          { title: '全部', val: '48' },
          { title: '铁路、道路、隧道和桥梁工程建筑', val: '481' },
          { title: '水利和水运工程建筑', val: '482' },
          { title: '海洋工程建筑', val: '483' },
          { title: '工矿工程建筑', val: '484' },
          { title: '架线和管道工程建筑', val: '485' },
          { title: '节能环保工程施工', val: '486' },
          { title: '电力工程施工', val: '487' },
          { title: '其他土木工程建筑', val: '489' },
        ],
      },
      {
        title: '建筑安装业',
        val: '49',
        terList: [
          { title: '全部', val: '49' },
          { title: '电气安装', val: '491' },
          { title: '管道和设备安装', val: '492' },
          { title: '其他建筑安装业', val: '499' },
        ],
      },
      {
        title: '建筑装饰、装修和其他建筑业',
        val: '50',
        terList: [
          { title: '全部', val: '50' },
          { title: '建筑装饰和装修业', val: '501' },
          { title: '建筑物拆除和场地准备活动', val: '502' },
          { title: '提供施工设备服务', val: '503' },
          { title: '其他未列明建筑业', val: '509' },
        ],
      },
    ],
  },
  {
    title: '批发和零售业',
    val: 'F',
    secList: [
      { title: '全部', val: 'F' },
      {
        title: '批发业',
        val: '51',
        terList: [
          { title: '全部', val: '51' },
          { title: '农、林、牧、渔产品批发', val: '511' },
          { title: '食品、饮料及烟草制品批发', val: '512' },
          { title: '纺织、服装及家庭用品批发', val: '513' },
          { title: '文化、体育用品及器材批发', val: '514' },
          { title: '医药及医疗器材批发', val: '515' },
          { title: '矿产品、建材及化工产品批发', val: '516' },
          { title: '机械设备、五金产品及电子产品批发', val: '517' },
          { title: '贸易经纪与代理', val: '518' },
          { title: '其他批发业', val: '519' },
        ],
      },
      {
        title: '零售业',
        val: '52',
        terList: [
          { title: '全部', val: '52' },
          { title: '综合零售', val: '521' },
          { title: '食品、饮料及烟草制品专门零售', val: '522' },
          { title: '纺织、服装及日用品专门零售', val: '523' },
          { title: '文化、体育用品及器材专门零售', val: '524' },
          { title: '医药及医疗器材专门零售', val: '525' },
          { title: '汽车、摩托车、零配件和燃料及其他动力销售', val: '526' },
          { title: '家用电器及电子产品专门零售', val: '527' },
          { title: '五金、家具及室内装饰材料专门零售', val: '528' },
          { title: '货摊、无店铺及其他零售业', val: '529' },
        ],
      },
    ],
  },
  {
    title: '交通运输、仓储和邮政业',
    val: 'G',
    secList: [
      { title: '全部', val: 'G' },
      {
        title: '铁路运输业',
        val: '53',
        terList: [
          { title: '全部', val: '53' },
          { title: '铁路旅客运输', val: '531' },
          { title: '铁路货物运输', val: '532' },
          { title: '铁路运输辅助活动', val: '533' },
        ],
      },
      {
        title: '道路运输业',
        val: '54',
        terList: [
          { title: '全部', val: '54' },
          { title: '城市公共交通运输', val: '541' },
          { title: '公路旅客运输', val: '542' },
          { title: '道路货物运输', val: '543' },
          { title: '道路运输辅助活动', val: '544' },
        ],
      },
      {
        title: '水上运输业',
        val: '55',
        terList: [
          { title: '全部', val: '55' },
          { title: '水上旅客运输', val: '551' },
          { title: '水上货物运输', val: '552' },
          { title: '水上运输辅助活动', val: '553' },
        ],
      },
      {
        title: '航空运输业',
        val: '56',
        terList: [
          { title: '全部', val: '56' },
          { title: '航空客货运输', val: '561' },
          { title: '通用航空服务', val: '562' },
          { title: '航空运输辅助活动', val: '563' },
        ],
      },
      {
        title: '管道运输业',
        val: '57',
        terList: [
          { title: '全部', val: '57' },
          { title: '海底管道运输', val: '571' },
          { title: '陆地管道运输', val: '572' },
        ],
      },
      {
        title: '多式联运和运输代理业',
        val: '58',
        terList: [
          { title: '全部', val: '58' },
          { title: '多式联运', val: '581' },
          { title: '运输代理业', val: '582' },
        ],
      },
      {
        title: '装卸搬运和仓储业',
        val: '59',
        terList: [
          { title: '全部', val: '59' },
          { title: '装卸搬运', val: '591' },
          { title: '通用仓储', val: '592' },
          { title: '低温仓储', val: '593' },
          { title: '危险品仓储', val: '594' },
          { title: '谷物、棉花等农产品仓储', val: '595' },
          { title: '中药材仓储', val: '596' },
          { title: '其他仓储业', val: '599' },
        ],
      },
      {
        title: '邮政业',
        val: '60',
        terList: [
          { title: '全部', val: '60' },
          { title: '邮政基本服务', val: '601' },
          { title: '快递服务', val: '602' },
          { title: '其他寄递服务', val: '609' },
        ],
      },
    ],
  },
  {
    title: '住宿和餐饮业',
    val: 'H',
    secList: [
      { title: '全部', val: 'H' },
      {
        title: '住宿业',
        val: '61',
        terList: [
          { title: '全部', val: '61' },
          { title: '旅游饭店', val: '611' },
          { title: '一般旅馆', val: '612' },
          { title: '民宿服务', val: '613' },
          { title: '露营地服务', val: '614' },
          { title: '其他住宿业', val: '619' },
        ],
      },
      {
        title: '餐饮业',
        val: '62',
        terList: [
          { title: '全部', val: '62' },
          { title: '正餐服务', val: '621' },
          { title: '快餐服务', val: '622' },
          { title: '饮料及冷饮服务', val: '623' },
          { title: '餐饮配送及外卖送餐服务', val: '624' },
          { title: '其他餐饮业', val: '629' },
        ],
      },
    ],
  },
  {
    title: '信息传输、软件和信息技术服务业',
    val: 'I',
    secList: [
      { title: '全部', val: 'I' },
      {
        title: '电信、广播电视和卫星传输服务',
        val: '63',
        terList: [
          { title: '全部', val: '63' },
          { title: '电信', val: '631' },
          { title: '广播电视传输服务', val: '632' },
          { title: '卫星传输服务', val: '633' },
        ],
      },
      {
        title: '互联网和相关服务',
        val: '64',
        terList: [
          { title: '全部', val: '64' },
          { title: '互联网接入及相关服务', val: '641' },
          { title: '互联网信息服务', val: '642' },
          { title: '互联网平台', val: '643' },
          { title: '互联网安全服务', val: '644' },
          { title: '互联网数据服务', val: '645' },
          { title: '其他互联网服务', val: '649' },
        ],
      },
      {
        title: '软件和信息技术服务业',
        val: '65',
        terList: [
          { title: '全部', val: '65' },
          { title: '软件开发', val: '651' },
          { title: '集成电路设计', val: '652' },
          { title: '信息系统集成和物联网技术服务', val: '653' },
          { title: '运行维护服务', val: '654' },
          { title: '信息处理和存储支持服务', val: '655' },
          { title: '信息技术咨询服务', val: '656' },
          { title: '数字内容服务', val: '657' },
          { title: '其他信息技术服务业', val: '659' },
        ],
      },
    ],
  },
  {
    title: '金融业',
    val: 'J',
    secList: [
      { title: '全部', val: 'J' },
      {
        title: '货币金融服务',
        val: '66',
        terList: [
          { title: '全部', val: '66' },
          { title: '中央银行服务', val: '661' },
          { title: '货币银行服务', val: '662' },
          { title: '非货币银行服务', val: '663' },
          { title: '银行理财服务', val: '664' },
          { title: '银行监管服务', val: '665' },
        ],
      },
      {
        title: '资本市场服务',
        val: '67',
        terList: [
          { title: '全部', val: '67' },
          { title: '证券市场服务', val: '671' },
          { title: '公开募集证券投资基金', val: '672' },
          { title: '非公开募集证券投资基金', val: '673' },
          { title: '期货市场服务', val: '674' },
          { title: '证券期货监管服务', val: '675' },
          { title: '资本投资服务', val: '676' },
          { title: '其他资本市场服务', val: '679' },
        ],
      },
      {
        title: '保险业',
        val: '68',
        terList: [
          { title: '全部', val: '68' },
          { title: '人身保险', val: '681' },
          { title: '财产保险', val: '682' },
          { title: '再保险', val: '683' },
          { title: '商业养老金', val: '684' },
          { title: '保险中介服务', val: '685' },
          { title: '保险资产管理', val: '686' },
          { title: '保险监管服务', val: '687' },
          { title: '其他保险活动', val: '689' },
        ],
      },
      {
        title: '其他金融业',
        val: '69',
        terList: [
          { title: '全部', val: '69' },
          { title: '金融信托与管理服务', val: '691' },
          { title: '控股公司服务', val: '692' },
          { title: '非金融机构支付服务', val: '693' },
          { title: '金融信息服务', val: '694' },
          { title: '金融资产管理公司', val: '695' },
          { title: '其他未列明金融业', val: '699' },
        ],
      },
    ],
  },
  {
    title: '房地产业',
    val: 'K',
    secList: [
      { title: '全部', val: 'K' },
      {
        title: '房地产业',
        val: '70',
        terList: [
          { title: '全部', val: '70' },
          { title: '房地产开发经营', val: '701' },
          { title: '物业管理', val: '702' },
          { title: '房地产中介服务', val: '703' },
          { title: '房地产租赁经营', val: '704' },
          { title: '其他房地产业', val: '709' },
        ],
      },
    ],
  },
  {
    title: '租赁和商务服务业',
    val: 'L',
    secList: [
      { title: '全部', val: 'L' },
      {
        title: '租赁业',
        val: '71',
        terList: [
          { title: '全部', val: '71' },
          { title: '机械设备经营租赁', val: '711' },
          { title: '文体设备和用品出租', val: '712' },
          { title: '日用品出租', val: '713' },
        ],
      },
      {
        title: '商务服务业',
        val: '72',
        terList: [
          { title: '全部', val: '72' },
          { title: '组织管理服务', val: '721' },
          { title: '综合管理服务', val: '722' },
          { title: '法律服务', val: '723' },
          { title: '咨询与调查', val: '724' },
          { title: '广告业', val: '725' },
          { title: '人力资源服务', val: '726' },
          { title: '安全保护服务', val: '727' },
          { title: '会议、展览及相关服务', val: '728' },
          { title: '其他商务服务业', val: '729' },
        ],
      },
    ],
  },
  {
    title: '科学研究和技术服务业',
    val: 'M',
    secList: [
      { title: '全部', val: 'M' },
      {
        title: '研究和试验发展',
        val: '73',
        terList: [
          { title: '全部', val: '73' },
          { title: '自然科学研究和试验发展', val: '731' },
          { title: '工程和技术研究和试验发展', val: '732' },
          { title: '农业科学研究和试验发展', val: '733' },
          { title: '医学研究和试验发展', val: '734' },
          { title: '社会人文科学研究', val: '735' },
        ],
      },
      {
        title: '专业技术服务业',
        val: '74',
        terList: [
          { title: '全部', val: '74' },
          { title: '气象服务', val: '741' },
          { title: '地震服务', val: '742' },
          { title: '海洋服务', val: '743' },
          { title: '测绘地理信息服务', val: '744' },
          { title: '质检技术服务', val: '745' },
          { title: '环境与生态监测检测服务', val: '746' },
          { title: '地质勘查', val: '747' },
          { title: '工程技术与设计服务', val: '748' },
          { title: '工业与专业设计及其他专业技术服务', val: '749' },
        ],
      },
      {
        title: '科技推广和应用服务业',
        val: '75',
        terList: [
          { title: '全部', val: '75' },
          { title: '技术推广服务', val: '751' },
          { title: '知识产权服务', val: '752' },
          { title: '科技中介服务', val: '753' },
          { title: '创业空间服务', val: '754' },
          { title: '其他科技推广服务业', val: '759' },
        ],
      },
    ],
  },
  {
    title: '水利、环境和公共设施管理业',
    val: 'N',
    secList: [
      { title: '全部', val: 'N' },
      {
        title: '水利管理业',
        val: '76',
        terList: [
          { title: '全部', val: '76' },
          { title: '防洪除涝设施管理', val: '761' },
          { title: '水资源管理', val: '762' },
          { title: '天然水收集与分配', val: '763' },
          { title: '水文服务', val: '764' },
          { title: '其他水利管理业', val: '769' },
        ],
      },
      {
        title: '生态保护和环境治理业',
        val: '77',
        terList: [
          { title: '全部', val: '77' },
          { title: '生态保护', val: '771' },
          { title: '环境治理业', val: '772' },
        ],
      },
      {
        title: '公共设施管理业',
        val: '78',
        terList: [
          { title: '全部', val: '78' },
          { title: '市政设施管理', val: '781' },
          { title: '环境卫生管理', val: '782' },
          { title: '城乡市容管理', val: '783' },
          { title: '绿化管理', val: '784' },
          { title: '城市公园管理', val: '785' },
          { title: '游览景区管理', val: '786' },
        ],
      },
      {
        title: '土地管理业',
        val: '79',
        terList: [
          { title: '全部', val: '79' },
          { title: '土地整治服务', val: '791' },
          { title: '土地调查评估服务', val: '792' },
          { title: '土地登记服务', val: '793' },
          { title: '土地登记代理服务', val: '794' },
          { title: '其他土地管理服务', val: '799' },
        ],
      },
    ],
  },
  {
    title: '居民服务、修理和其他服务业',
    val: 'O',
    secList: [
      { title: '全部', val: 'O' },
      {
        title: '居民服务业',
        val: '80',
        terList: [
          { title: '全部', val: '80' },
          { title: '家庭服务', val: '801' },
          { title: '托儿所服务', val: '802' },
          { title: '洗染服务', val: '803' },
          { title: '理发及美容服务', val: '804' },
          { title: '洗浴和保健养生服务', val: '805' },
          { title: '摄影扩印服务', val: '806' },
          { title: '婚姻服务', val: '807' },
          { title: '殡葬服务', val: '808' },
          { title: '其他居民服务业', val: '809' },
        ],
      },
      {
        title: '机动车、电子产品和日用产品修理业',
        val: '81',
        terList: [
          { title: '全部', val: '81' },
          { title: '汽车、摩托车等修理与维护', val: '811' },
          { title: '计算机和办公设备维修', val: '812' },
          { title: '家用电器修理', val: '813' },
          { title: '其他日用产品修理业', val: '819' },
        ],
      },
      {
        title: '其他服务业',
        val: '82',
        terList: [
          { title: '全部', val: '82' },
          { title: '清洁服务', val: '821' },
          { title: '宠物服务', val: '822' },
          { title: '其他未列明服务业', val: '829' },
        ],
      },
    ],
  },
  {
    title: '教育',
    val: 'P',
    secList: [
      { title: '全部', val: 'P' },
      {
        title: '教育',
        val: '83',
        terList: [
          { title: '全部', val: '83' },
          { title: '学前教育', val: '831' },
          { title: '初等教育', val: '832' },
          { title: '中等教育', val: '833' },
          { title: '高等教育', val: '834' },
          { title: '特殊教育', val: '835' },
          { title: '技能培训、教育辅助及其他教育', val: '839' },
        ],
      },
    ],
  },
  {
    title: '卫生和社会工作',
    val: 'Q',
    secList: [
      { title: '全部', val: 'Q' },
      {
        title: '卫生',
        val: '84',
        terList: [
          { title: '全部', val: '84' },
          { title: '医院', val: '841' },
          { title: '基层医疗卫生服务', val: '842' },
          { title: '专业公共卫生服务', val: '843' },
          { title: '其他卫生活动', val: '849' },
        ],
      },
      {
        title: '社会工作',
        val: '85',
        terList: [
          { title: '全部', val: '85' },
          { title: '提供住宿社会工作', val: '851' },
          { title: '不提供住宿社会工作', val: '852' },
        ],
      },
    ],
  },
  {
    title: '文化、体育和娱乐业',
    val: 'R',
    secList: [
      { title: '全部', val: 'R' },
      {
        title: '新闻和出版业',
        val: '86',
        terList: [
          { title: '全部', val: '86' },
          { title: '新闻业', val: '861' },
          { title: '出版业', val: '862' },
        ],
      },
      {
        title: '广播、电视、电影和录音制作业',
        val: '87',
        terList: [
          { title: '全部', val: '87' },
          { title: '广播', val: '871' },
          { title: '电视', val: '872' },
          { title: '影视节目制作', val: '873' },
          { title: '广播电视集成播控', val: '874' },
          { title: '电影和广播电视节目发行', val: '875' },
          { title: '电影放映', val: '876' },
          { title: '录音制作', val: '877' },
        ],
      },
      {
        title: '文化艺术业',
        val: '88',
        terList: [
          { title: '全部', val: '88' },
          { title: '文艺创作与表演', val: '881' },
          { title: '艺术表演场馆', val: '882' },
          { title: '图书馆与档案馆', val: '883' },
          { title: '文物及非物质文化遗产保护', val: '884' },
          { title: '博物馆', val: '885' },
          { title: '烈士陵园、纪念馆', val: '886' },
          { title: '群众文体活动', val: '887' },
          { title: '其他文化艺术业', val: '889' },
        ],
      },
      {
        title: '体育',
        val: '89',
        terList: [
          { title: '全部', val: '89' },
          { title: '体育组织', val: '891' },
          { title: '体育场地设施管理', val: '892' },
          { title: '健身休闲活动', val: '893' },
          { title: '其他体育', val: '899' },
        ],
      },
      {
        title: '娱乐业',
        val: '90',
        terList: [
          { title: '全部', val: '90' },
          { title: '室内娱乐活动', val: '901' },
          { title: '游乐园', val: '902' },
          { title: '休闲观光活动', val: '903' },
          { title: '彩票活动', val: '904' },
          { title: '文化体育娱乐活动与经纪代理服务', val: '905' },
          { title: '其他娱乐业', val: '909' },
        ],
      },
    ],
  },
  {
    title: '公共管理、社会保障和社会组织',
    val: 'S',
    secList: [
      { title: '全部', val: 'S' },
      {
        title: '中国共产党机关',
        val: '91',
        terList: [
          { title: '全部', val: '91' },
          { title: '中国共产党机关', val: '910' },
        ],
      },
      {
        title: '国家机构',
        val: '92',
        terList: [
          { title: '全部', val: '92' },
          { title: '国家权力机构', val: '921' },
          { title: '国家行政机构', val: '922' },
          { title: '监察委员会、人民法院和人民检察院', val: '923' },
          { title: '其他国家机构', val: '929' },
        ],
      },
      {
        title: '人民政协、民主党派',
        val: '93',
        terList: [
          { title: '全部', val: '93' },
          { title: '人民政协', val: '931' },
          { title: '民主党派', val: '932' },
        ],
      },
      {
        title: '社会保障',
        val: '94',
        terList: [
          { title: '全部', val: '94' },
          { title: '基本保险', val: '941' },
          { title: '补充保险', val: '942' },
          { title: '其他社会保障', val: '949' },
        ],
      },
      {
        title: '群众团体、社会团体和其他成员组织',
        val: '95',
        terList: [
          { title: '全部', val: '95' },
          { title: '群众团体', val: '951' },
          { title: '社会团体', val: '952' },
          { title: '基金会', val: '953' },
          { title: '宗教组织', val: '954' },
        ],
      },
      {
        title: '基层群众自治组织及其他组织',
        val: '96',
        terList: [
          { title: '全部', val: '96' },
          { title: '社区居民自治组织', val: '961' },
          { title: '村民自治组织', val: '962' },
        ],
      },
    ],
  },
  {
    title: '国际组织',
    val: 'T',
    secList: [
      { title: '全部', val: 'T' },
      {
        title: '国际组织',
        val: '97',
        terList: [
          { title: '全部', val: '97' },
          { title: '国际组织', val: '970' },
        ],
      },
    ],
  },
];

// 企业描述
// 机构类型
export const companyType = [
  { title: '全部', key: '*', val: '*' },
  { title: '企业', key: '1', val: 'normal_company' },
  { title: '事业单位', key: '2', val: 'institution' },
  { title: '基金会', key: '3', val: 'npo_foundation' },
  { title: '社会团体', key: '4', val: 'npo' },
  { title: '律师事务所', key: '5', val: 'lawFirm' },
  { title: '中国香港企业', key: '6', val: 'hk' },
  { title: '中国台湾企业', key: '7', val: 'tw' },
  { title: '机关机构', key: '8', val: 'organization' },
];
// 资本类型
export const capitalType = [
  { title: '全部', val: '*' },
  { title: '人民币', val: '1' },
  { title: '美元', val: '2' },
  { title: '其它', val: '3' },
];
// 企业类型
export const orgType = [
  { title: '全部', val: '*' },
  { title: '有限责任公司', val: '1' },
  { title: '股份有限公司', val: '2' },
  { title: '集体所有制', val: '3' },
  { title: '股份合作制', val: '13' },
  { title: '国有企业', val: '4' },
  { title: '个体工商户', val: '5' },
  { title: '个人独资企业', val: '12' },
  { title: '有限合伙', val: '6' },
  { title: '普通合伙', val: '7' },
  { title: '外商投资企业', val: '8' },
  { title: '港、澳、台', val: '9' },
  { title: '联营企业', val: '10' },
  { title: '私营企业', val: '11' },
];
// 企业类型描述
export const orgDesc = {
  describe: [
    '<b>有限责任公司</b> <br>一般而言，是指由五十个以下的股东出资设立，每个股东以其所认缴的出资额为限对公司承担有限责任，公司法人以其全部资产对公司债务承担全部责任的经济组织。包括国有独资公司以及其他有限责任公司。',
    '<b>股份有限公司</b> <br>一般而言，是指公司资本为股份所组成的公司，股东以其认购的股份为限对公司承担责任的企业法人。',
    '<b>集体所有制</b> <br>一般而言，是指生产资料属于劳动群众集体所有、实行共同劳动、在分配方式上以按劳分配为主体的社会主义经济组织。',
    '<b>股份合作制</b> <br>一般而言，是指以合作制为基础，由企业职工共同出资入股，吸收一定比例的社会资产投资组建，实行自主经营，自负盈亏，共同劳动，民主管理，按劳分配与按股分红相结合的一种集体经济组织。',
    '<b>国有企业</b> <br>一般而言，是指国务院和地方人民政府分别代表国家履行出资人职责的国有独资企业、国有独资公司以及国有资本控股公司，包括中央和地方国有资产监督管理机构和其他部门所监管的企业本级及其逐级投资形成的企业。',
    '<b>个体工商户</b> <br>一般而言，是指不具备法人资格，自然人从事工商经营，经依法登记，为个体工商户。个体工商户可分为个人经营和家庭经营。',
    '<b>个人独资企业</b> <br>一般而言，是指由一个自然人投资，财产为投资人个人所有，投资人以其个人财产对企业债务承担无限责任的经营实体，不具备法人资格。',
    '<b>有限合伙</b> <br>一般而言，是指由普通合伙人和有限合伙人组成，普通合伙人对合伙企业债务承担无限连带责任，有限合伙人以其认缴的出资额为限对合伙企业债务承担责任。',
    '<b>普通合伙</b> <br>一般而言，是指由普通合伙人组成，合伙人对合伙企业债务承担无限连带责任。',
    '<b>外商投资企业</b> <br>一般而言，是指依照中国法律在中国境内设立的，由中国投资者与外国投资者共同投资，或者由外国投资者单独投资的企业。',
    '<b>港澳台</b> <br>一般而言，是指依照中国法律在中国境内注册登记的，台港澳资本投资兴办的独立经营或者同国内企业合作生产、合作经营的公司、企业和其他经济组织。',
    '<b>联营企业</b> <br>一般而言，是指两个及两个以上相同或不同所有制性质的企业法人或事业单位法人，按自愿、平等、互利的原则，共同投资组成的经济组织。',
    '<b>私营企业</b> <br>一般而言，是指由自然人投资设立或由自然人控股，以雇佣劳动为基础的营利性经济组织。私营企业包括私营有限责任公司、私营股份有限公司、私营合伙企业和私营独资企业。',
  ],
};

// 人员规模
export const staffSize = [
  { title: '全部', val: '*' },
  { val: '050', start: 0, end: 50, title: '小于50人', sort: 1 },
  { val: '5099', start: 50, end: 99, title: '50-99人', sort: 2 },
  { val: '100499', start: 100, end: 499, title: '100-499人', sort: 3 },
  { val: '500999', start: 500, end: 999, title: '500-999人', sort: 4 },
  { val: '4999', start: 1000, end: 4999, title: '1000-4999人', sort: 5 },
  { val: '9999', start: 5000, end: 9999, title: '5000-9999人', sort: 6 },
  { val: '10000', start: 10000, end: -1, title: '10000人以上', sort: 7 },
];

// VIP 筛选
export const highFilter = {
  hasPhone: [
    { val: '*', title: '全部' },
    { val: '1', title: '有联系方式' },
    { val: '0', title: '无联系方式' },
  ],
  contactType: [
    { val: '*', title: '全部' },
    { val: '1', title: '全部联系方式' },
    { val: '2', title: '有固定电话' },
    { val: '3', title: '有手机号' },
  ],
  emptyPhoneFilter: [
    { val: '*', title: '全部' },
    { val: '1', title: '过滤无效电话' },
  ],
  hasMobile: [
    { val: '*', title: '全部' },
    { val: '1', title: '有手机号码' },
    { val: '0', title: '无手机号码' },
  ],
  hasEmail: [
    { val: '*', title: '全部' },
    { val: '1', title: '有联系邮箱' },
    { val: '0', title: '无联系邮箱' },
  ],
  hasTm: [
    { val: '*', title: '全部' },
    { val: '1', title: '有商标信息' },
    { val: '0', title: '无商标信息' },
  ],
  hasPatent: [
    { val: '*', title: '全部' },
    { val: '1', title: '有专利信息' },
    { val: '0', title: '无专利信息' },
  ],
  hasCopyright: [
    { val: '*', title: '全部' },
    { val: '1', title: '有软件著作权' },
    { val: '0', title: '无软件著作权' },
  ],
  hasBid: [
    { val: '*', title: '全部' },
    { val: '1', title: '有招投标' },
    { val: '0', title: '无招投标' },
  ],
  // 这块内容需要转义
  hasFinancing: [
    { val: '*', title: '全部' },
    { val: '未融资', value: '未融资', title: '未融资' },
    { val: '天使/种子轮', value: '天使/种子轮', title: '天使/种子轮' },
    { val: 'PreA至A+轮', value: 'PreA至A+轮', title: 'PreA至A+轮' },
    { val: 'PreB至B+轮', value: 'PreB至B+轮', title: 'PreB至B+轮' },
    { val: 'C轮及以上', value: 'C轮及以上', title: 'C轮及以上' },
    { val: 'IPO上市', value: 'IPO上市', title: 'IPO上市' },
    { val: '并购/合并', value: '并购/合并', title: '并购/合并' },
    { val: '战略融资/投资', value: '战略融资/投资', title: '战略融资/投资' },
    { val: '股权融资/转让', value: '股权融资/转让', title: '股权融资/转让' },
    { val: '定向增发', value: '定向增发', title: '定向增发' },
    { val: '其它', value: '其它', title: '其它' },
  ],
  hasBondType: [
    { val: '*', title: '全部' },
    { val: '未上市', value: '未上市', title: '未上市' },
    { val: 'A股', value: 'A股', title: 'A股' },
    { val: '中概股', value: '中概股', title: '中概股' },
    { val: '港股', value: '港股', title: '港股' },
    { val: '科创板', value: '科创板', title: '科创板' },
    { val: '新三板', value: '新三板', title: '新三板' },
    { val: '新四板', value: '新四板', title: '新四板' },
  ],
  isTaxpayer: [
    { val: '*', title: '全部' },
    { val: '1', title: '是一般纳税人' },
    { val: '0', title: '非一般纳税人' },
  ],
  isTaxLevel: [
    { val: '*', title: '全部' },
    { val: '1', title: 'A级' },
    { val: '0', title: '非A级' },
  ],
  hasDishonest: [
    { val: '*', title: '全部' },
    { val: '1', title: '有失信信息' },
    { val: '0', title: '无失信信息' },
  ],
  website: [
    { val: '*', title: '全部' },
    { val: '1', title: '有网址信息' },
    { val: '0', title: '无网址信息' },
  ],
  top500: [
    { val: '*', title: '全部' },
    { val: '1', title: '中国500强' },
    { val: '2', title: '世界500强' },
  ],
  hasWorkCopr: [
    { val: '*', title: '全部' },
    { val: '1', title: '有作品著作权' },
    { val: '0', title: '无作品著作权' },
  ],
  hasMortgage: [
    { val: '*', title: '全部' },
    { val: '1', title: '有动产抵押' },
    { val: '0', title: '无动产抵押' },
  ],
  isHighTechCompany: [
    { val: '*', title: '全部' },
    { val: '1', title: '是高新技术企业' },
    { val: '0', title: '不是高新技术企业' },
  ],
  isClaimed: [
    { val: '1', title: '已认证' },
    { val: '0', title: '未认证' },
  ],
};

// 空号识别 描述
export const khsbDesc = {
  describe: ['<b>空号识别</b> <br>仅检测大陆手机号，固话通过同企业电话数据量给出意见判断'],
  subDescribe: [
    {
      title: '有效电话',
      desc: [
        {
          icon: 'dianhua_zhengchang',
          text: '号码可正常联系',
        },
        {
          icon: 'dianhua_guhua',
          text: '固定电话或非大陆号码',
        },
      ],
    },
    {
      title: '未知电话',
      desc: [
        {
          icon: 'dianhua_jiance',
          text: '号码检测中，将持续更新',
        },
      ],
    },
    {
      title: '无效电话',
      desc: [
        {
          icon: 'dianhua_konghao',
          text: '空号、停机、沉默号、风险号，或同企业电话数量过多等，建议跳过',
        },
      ],
    },
  ],
};

// 融资信息 描述
export const rzxxDesc = {
  describe: [
    '<b>未融资</b> <br>一般而言，是指企业并未以任何方式进行融资。',
    '<b>天使/种子轮</b> <br> 天使投资（Angel Investment），一般而言是指个人出资协助具有专门技术或独特概念而缺少自有资金的创业家进行创业，并承担创业中的高风险和享受创业成功后的高收益。 种子轮，一般而言是指种子融资，一种最早期阶段进行的融资方式。',
    '<b>PreA至A+轮</b> <br>Pre A，一般而言是指介于天使轮与A轮之间的融资阶段。 <br> A+轮，一般而言是指A轮融资完成但未达到B轮融资要求的融资阶段。',
    '<b>PreB至B+轮</b> <br>Pre B，一般而言是指介于A轮与B轮之间的融资阶段。<br> B+轮，一般而言是指B轮融资完成但未达到C轮融资要求的融资阶段。',
    '<b>C轮及以上</b> <br> 一般而言，是指C轮及以上融资轮次是公司发展成熟，基本实现盈利，正在向上市方向准备的融资阶段。',
    '<b>IPO上市</b> <br>一般而言，是指首次公开发行（Initial Public Offering），指发行人首次向社会公众投资者发售其公司股份的行为。',
    // eslint-disable-next-line no-tabs
    '<b>并购/合并</b> <br>企业并购，一般而言是指以现金、债券、股票或其他有价证券的形式，通过收购债权、直接出资、控股及其他多种手段购买其他企业的股票或资 产取得其他企业的资产实际控制权使其失去法人地位或对其拥有控制权的行为。<br>企业合并，一般而言是指分为吸收合并和新设合并。 吸收合并是指一个公司吸收其他公司为吸收合并，被吸收的公司解散。新设合并是指两个以上公司合并设立一个新的公司为新设合并，合并各方解散。		',
    '<b>战略融资/投资</b> <br>战略融资，一般而言是指企业接受投资方不以财务收益为唯一目标，而是以产业协同或其它作为目标进而筹集资金的过程。该企业往往引入的是对企业业务发展有重大影响的投资人。<br> 战略投资，一般而言是指投资方不以财务收益为唯一目标，而是以产业协同或其它作为目标，进而投放足够数额的资金或实物的货币等价物的行为。',
    '<b>股权融资/转让</b> <br>股权融资，一般而言是指公司股东愿意让出部分股权，通过定向增资的方式引进新的股东的融资方式，所获得的资金可用于充实公司的营运资金。<br>股权转让，一般而言是指企业的股东将其持有的股份或出资部分或全部转让给他人。',
    // eslint-disable-next-line no-tabs
    '<b>定向增发</b> <br>定向增发是增发的一种，一般而言是指上市公司向符合条件的少数特定投资者非公开发行股份的行为。	',
  ],
};

// 上市状态 描述
export const ssztDesc = {
  describe: [
    '<b>上市公司</b> <br>一般而言，是指其股票在证券交易所上市交易的股份有限公司。',
    '<b>A股</b> <br>一般而言，是指“人民币普通股票”，是由我国境内注册公司发行，在境内注册公司发行，在境内上市，供境内机构，组织或个人（2013年4月1日起，境内港澳台居民可立A股账户）以人民币认购和交易的普通股股票。',
    '<b>中概股</b> <br>全称为“中国概念股”，一般而言，是指在国外上市的中国注册的公司，或虽在国外注册但主营业务和实际控制方在大陆的公司的股票，包括在海外直接上市和间接上市两种。',
    '<b>港股</b> <br>一般而言，是指在中华人民共和国香港特别行政区的香港联合交易所上市的股票。',
    '<b>新三板</b> <br>一般而言，是指“全国股份转让系统”，该系统是经国务院批准，依据证券法设立的全国性证券交易场所，主要为创新型、创业型、成长型中小微企业发展服务。原指中关村科技园区非上市股份有限公司进入代办股份系统进行转让试点的场所。',
    // eslint-disable-next-line no-tabs
    '<b>新四板</b> <br>	一般而言，是指“区域性股权交易市场”，是由省级地方政府管理的、为该省级行政区域内中小微企业证券非公开发行、转让及相关活动提供设施与服务的场所。',
    '<b>科创板</b> <br>一般而言，是指于2018年11月5日宣布设立并注册制的独立于主板的新设板块，主要是针对的是尚未进入成熟期但具有成长潜力，且符合战略新兴产业发展方向及科技型、创新型特征的中小初创型企业。',
  ],
};

// 企业状态 描述
export const zyztDeac = {
  describe: [
    '<b>存续（在营、开业、在业）</b> <br>一般而言，是指企业依法存在并继续正常运营。',
    '<b>吊销</b> <br>一般而言，是指公司登记主管机关根据有关法律法规的规定，对有严重违法违规行为的企业依法以强制手段剥夺其经营资格的一种行政处罚。',
    '<b>注销</b> <br>一般而言，是指企业自行通过法定流程申请注销营业执照以终止公司法人资格。',
    '<b>停业</b> <br>一般而言，是指由某种原因，企业在期末处于停止生产经营活动待条件改变后仍恢复生产。包括自行停业和责令停产停业。',
    '<b>撤销</b> <br>一般而言，是指因不满足法定登记条件，被登记机关强制撤回已生效文件、证书或营业执照等，使之恢复登记前状态的行政行为。',
    '<b>迁入</b> <br>一般而言，是指企业登记主管机关的变更，迁入新主管机关。',
    '<b>迁出</b> <br>一般而言，是指企业登记主管机关的变更，迁出新主管机关。',
  ],
};

export const regStatusNew = [
  { title: '全部', val: '*' },
  { title: '存续、在业', val: '1' },
  { title: '迁出', val: '5' },
  { title: '迁入', val: '9' },
  { title: '停业', val: '6' },
  { title: '已歇业', val: '11' },
  { title: '吊销', val: '3' },
  { title: '清算', val: '12' },
  { title: '撤销', val: '7' },
  { title: '注销', val: '4' },
];

export const searchSort = [
  { title: '默认排序', val: '0' },
  { title: '注册资本从高到低', val: '1' },
  { title: '注册资本从低到高', val: '2' },
  { title: '成立日期从早到晚', val: '4' },
  { title: '成立日期从晚到早', val: '3' },
];

export const getSearchSort = (val: string) => {
  for (const i in searchSort) {
    if (searchSort[i].val === val) {
      return searchSort[i];
    }
  }

  return { title: '默认排序', val: '0' };
};

/**
 * 查找筛选项对应的配置-某个value的配置
 */
export const getObjectForValue = (config: IConfigItemProps[], val: string) => {
  for (const key of config) {
    if (key.val === val) {
      return key;
    }
  }

  return { val: '' };
};

/**
 * 查找筛选项对应的配置
 */
export const getObjectForKeyAndValue = (key: string, value: string): IConfigItemProps => {
  switch (key) {
    case filterFlag.LIST_SORT:
      return getObjectForValue(searchSort, value);
    case filterFlag.REG_CAPITIAL:
      return getObjectForValue(regCapital, value);
    case filterFlag.ESTIBLISH_TIME:
      return getObjectForValue(estiblishTime, value);
    case filterFlag.CAPITAL_TYPE:
      return getObjectForValue(capitalType, value);
    case filterFlag.ORG_TYPE:
      return getObjectForValue(orgType, value);
    case filterFlag.STAFF_SIZE:
      return getObjectForValue(staffSize, value);
    case filterFlag.CONTACT_TYPE:
      return getObjectForValue(highFilter.contactType, value);
    case filterFlag.EMPTY_PHONE:
      return getObjectForValue(highFilter.emptyPhoneFilter, value);
    case filterFlag.HAS_EMAIL:
      return getObjectForValue(highFilter.hasEmail, value);
    case filterFlag.HAS_TM:
      return getObjectForValue(highFilter.hasTm, value);
    case filterFlag.HAS_PATENT:
      return getObjectForValue(highFilter.hasPatent, value);
    case filterFlag.HAS_FINANCING:
      return getObjectForValue(highFilter.hasFinancing, value); // todo
    case filterFlag.HAS_BOND_TYPE:
      return getObjectForValue(highFilter.hasBondType, value);
    case filterFlag.IS_TAX_LEVEL:
      return getObjectForValue(highFilter.isTaxLevel, value);
    case filterFlag.IS_TAX_PAYER:
      return getObjectForValue(highFilter.isTaxpayer, value);
    case filterFlag.HAS_BID:
      return getObjectForValue(highFilter.hasBid, value);
    case filterFlag.HAS_DISHONEST:
      return getObjectForValue(highFilter.hasDishonest, value);
    case filterFlag.WEBSITE:
      return getObjectForValue(highFilter.website, value);
    case filterFlag.HAS_MORTGAGE:
      return getObjectForValue(highFilter.hasMortgage, value);
    case filterFlag.TOP500:
      return getObjectForValue(highFilter.top500, value);
    case filterFlag.HAS_WORK_COPR:
      return getObjectForValue(highFilter.hasWorkCopr, value);
    case filterFlag.HAS_COPY_RIGHT:
      return getObjectForValue(highFilter.hasCopyright, value);
    case filterFlag.IS_HIGH_TECH_COMPANY:
      return getObjectForValue(highFilter.isHighTechCompany, value);
    case filterFlag.REG_STATUS:
      return getObjectForValue(regStatusNew, value);
  }

  if (key === filterFlag.CATE) {
    const res: IConfigItemProps = {};

    // 打平行业数据
    for (const cateKey of cateList) {
      if (cateKey.val === value) {
        res.categoryGuobiao2017 = value;
        break;
      }
      const secList = cateKey.secList || [];
      for (const secKey of secList) {
        if (secKey.val === value) {
          res.categoryGuobiao2017 = cateKey.val;
          res.secInduCode = secKey.val;
          break;
        }

        const terList = secKey.terList || [];
        for (const terKey of terList) {
          if (terKey.val === value) {
            res.categoryGuobiao2017 = cateKey.val;
            res.secInduCode = secKey.val;
            res.terInduCode = terKey.val;
            break;
          }
        }
      }
    }

    return res;
  }

  return { val: '' };
};

/**
 * 获取某省-城市数据
 */
export const getCityForCityList = (cityList: any[], base: string) => {
  const target = cityList.filter((item: any) => item.base === base)?.[0] || {};

  return target.city || [];
};

/**
 * 获取某省-某市-地区下城市数据
 */
export const getDistrictForCityList = (cityList: any[], base: string, city: string) => {
  let target;
  (cityList || []).forEach((ele) => {
    if (ele.base === base) {
      const list = ele.city || [];
      for (let i = 0; i < list.length; i++) {
        const el = list[i];
        // 直辖市
        if (el.base === city || el.base === base) {
          target = el.district || [];
          break;
        }
      }
    }
  });
  return target || [];
};

/**
 * 获取某行业分析-行业大类数据
 */
export const getSecInduCodeForCateList = (categoryGuobiao2017: string) => {
  const target = cateList.filter((item: any) => item.val === categoryGuobiao2017)?.[0] || {};

  return target.secList || [];
};

/**
 * 获取某行业分析-某行业大类-行业数据
 */
export const getTerInduCodeForCateList = (categoryGuobiao2017: string, secInduCode: string) => {
  let target;
  cateList.forEach((ele) => {
    if (ele.val === categoryGuobiao2017) {
      const secList = ele.secList || [];
      for (let i = 0; i < secList.length; i++) {
        const el = secList[i];
        if (el.val === secInduCode) {
          target = el.terList || [];
          break;
        }
      }
    }
  });
  return target || [];
};
